class TrMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.playButtons = this.querySelectorAll('.tr-media__play-button');
    this.autoplay = this.dataset.autoplay === 'true';

    if (this.videos.length === 0) return;

    if (this.playButtons.length > 0) {
      this.playButtons.forEach(button => {
        button.addEventListener('click', this.togglePlay.bind(this));
      });
    }

    if (!this.autoplay) {
      this.videos.forEach(video => {
        video.addEventListener('click', this.togglePlay.bind(this));
        
        video.addEventListener('pause', () => {
          this.playButtons.forEach(btn => btn.hidden = false);
        });
        
        video.addEventListener('play', () => {
          this.playButtons.forEach(btn => btn.hidden = true);
        });
      });
    }
  }

  togglePlay() {
    this.videos.forEach(video => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
  }
}

if (!customElements.get('tr-media')) {
  customElements.define('tr-media', TrMedia);
}
